import React from 'react';

import { useScrollThreshold, UseScrollThresholdOptions } from '@shared/hooks/use-scroll-threshold';

import * as Styled from './button-to-top.styled';
import { ChevronIcon } from '../icons';

type OwnProps = UseScrollThresholdOptions & { className?: string };

export const ButtonToTop = ({ rootRef, screenfuls, className }: OwnProps) => {
	const isVisible = useScrollThreshold({ rootRef, screenfuls });

	const scrollToTop = () => {
		const el = rootRef?.current;
		if (el) el.scrollTo({ top: 0, behavior: 'smooth' });
		else window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	if (!isVisible) {
		return null;
	}

	return (
		<Styled.ScrollToTopButton className={className} onClick={scrollToTop}>
			<ChevronIcon.Up />
		</Styled.ScrollToTopButton>
	);
};
